module.exports = __webpack_public_path__ + "static/media/faq-accordion-close.ea165034.svg";